module.exports = __webpack_public_path__ + "img/github.8d4af435.svg";